module.exports = __webpack_public_path__ + "static/img/rp.417a20a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/rp.jpeg
// module id = 757
// module chunks = 1